// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner__1KBbz {\n  height: 36px;\n  grid-area: banner;\n  background-color: #F6F6F6;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-family: Inter, Arial, Helvetica, sans-serif;\n  font-size: 12px;\n}\n\n.link__1X2kL {\n  margin-left: 17px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  color: #0467D2;\n\n  &:hover {\n    color: #00389E;\n  }\n}\n\n.divider__205BP {\n  height: 16px;\n  border-left: 1px solid #BCBCBC;\n  margin: 8px;\n}\n\n.details__3F4Fz {\n  font-weight: 500;\n  color: #000;\n}\n\n/* Mobile styles (under 480px) */\n@media only screen and (max-width: 480px) {\n  .banner__1KBbz {\n    font-size: 10px;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"banner": "banner__1KBbz",
	"link": "link__1X2kL",
	"divider": "divider__205BP",
	"details": "details__3F4Fz"
};
module.exports = exports;
